import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "module-title" }

import { NCard, NSpace, NGrid, NGridItem } from 'naive-ui'
import { Icon } from '@iconify/vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyModule',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCard), { class: "module module--empty" }, {
    default: _withCtx(() => [
      _createVNode(_unref(NGrid), {
        cols: 6,
        "x-gap": "24",
        "y-gap": "24"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NGridItem), { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                align: "center",
                "wrap-item": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:information-outline",
                    style: { fontSize: '24px' }
                  }),
                  _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref(t)('modules.noModules.index')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(NGridItem), { span: 6 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('modules.noModules.content')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})